import React, { ReactNode } from "react";

import { RouteComponentProps, withRouter } from "react-router-dom";

import { Box } from "@mui/material";

import { PlayerPageState } from "./models";

import { ContentEnduserService } from "services/content-enduser-service";
import AuthenticationService from "services/authentication-service";

import ZPlayLoader from "commons/zplay-loader";

import { Player } from "components/player-page/player/player";
import { PlayerInfoOverlay } from "components/player-page/player/player-info-overlay/player-info-overlay";
import PaywallModal from "components/modals/paywall-modal";
import RegisteredModal from "components/modals/registered-modal";
import MandatorySubscriptionModal from "components/modals/mandatory-subscription-modal";
import GeoBlockedModal from "components/modals/geoblocked-modal";

import { selectDescriptionByLanguage } from "utils";
import { Content, User } from "models";
import { ErrorResponseApi } from "models/response";


class PlayerPage extends React.Component<RouteComponentProps<any>, PlayerPageState> {

    constructor(props: any) {

        super(props);

        this.state = {
            isLoading: true,
            user: null,
            errorString: "",
            hasError: false,
            currentUser: null,
            isAlreadyFavorite: false,
            isAlreadyLiked: false,
            showRegistrationDialog: false,
            content: null,
            showInfoOverlay: false
        };
    }

    private renderErrorModal = (): ReactNode => {

        let currentUser: User | null = this.state.currentUser;

        if (this.state.errorString.includes("GEO_BLOCK")) {
            return <GeoBlockedModal />;
        }

        if (!currentUser && this.state.errorString.includes("NOT_REG")) {
            return <RegisteredModal />;
        }

        if (this.state.errorString.includes("PPV_ERR")) {
            return <PaywallModal buyCallbackFn={this.buyContent} />;
        }

        if (this.state.errorString.includes("NOT_SUB")) {
            return <MandatorySubscriptionModal />;
        }

        return null;
    }

    timer: NodeJS.Timeout | undefined

    private getCurrentUserSuccessCb = (data: User) => {

        this.setState(() => ({
            currentUser: data
        }))

        ContentEnduserService.getContentById(this.props.match.params.contentId, this.getContentSuccessCallback, this.errorCallback)
    }


    private getCurrentUserErrorCb = () => {
        ContentEnduserService.getContentById(this.props.match.params.contentId, this.getContentSuccessCallback, this.errorCallback)
    }

    componentDidMount() {

        AuthenticationService.getCurrentUser(this.getCurrentUserSuccessCb, this.getCurrentUserErrorCb)

    }

    getContentSuccessCallback = (data: Content) => {

        this.setState(() => ({
            isLoading: false,
            isAlreadyFavorite: this.state.currentUser?.favoriteContentIdList.includes(data.id) || false,
            isAlreadyLiked: this.state.currentUser?.likedContentIdList.includes(data.id) || false,
            content: data
        }))

        console.log(this.state.currentUser)
    }

    errorCallback = (err: ErrorResponseApi) => {

        this.setState(() => ({ isLoading: false, hasError: true, errorString: err.error }));
    }

    buyContentSuccessCallback = (data: any) => {
        window.location.replace(data.url);
    }

    buyContent = () => {
        ContentEnduserService.buyContent(this.props.match.params.contentId, this.buyContentSuccessCallback, this.errorCallback)
    }

    showOverlay = () => {

        let overlayTime = 800;

        if (!this.state.showInfoOverlay) {
            this.setState(() => ({ showInfoOverlay: true }))
            this.timer = setTimeout(() => {
                this.setState(() => ({ showInfoOverlay: false }));
            }, overlayTime);

        } else {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.setState(() => ({ showInfoOverlay: false }));
            }, overlayTime);
        }
    };

    private setContentAsFavorite = () => {
        if (this.state.content)
            ContentEnduserService.setContentFavorite(this.state.content?.id, this.setContentAsFavoriteCb, () => { })
    }

    private setContentAsFavoriteCb = () => {
        this.setState(() => ({ isAlreadyFavorite: true }))
    }


    private setContentLikedeCb = () => {
        this.setState(() => ({ isAlreadyLiked: true }))
    }


    private likeContent = () => {
        if (this.state.content)
            ContentEnduserService.likeContent(this.state.content?.id, this.setContentLikedeCb, () => { })
    }

    render() {
        return (<>
            {this.state.isLoading && <ZPlayLoader />}
            {(!this.state.isLoading && this.state.content && !this.state.hasError) && <><Box onMouseMove={this.showOverlay} style={{ width: "100vw" }}>
                <PlayerInfoOverlay
                    isAlreadyLiked={this.state.isAlreadyLiked}
                    isAlreadyFavorite={this.state.isAlreadyFavorite}
                    showActions={this.state.currentUser !== null}
                    setFavoriteCallbackFn={this.setContentAsFavorite}
                    setLikeCallbackFn={this.likeContent}
                    showInfoOverlay={this.state.showInfoOverlay}
                    contentName={selectDescriptionByLanguage(this.state.content.title, this.state.content.language)}
                />
                <Player content={this.state.content} />
            </Box></>
            }
            {(!this.state.isLoading && this.state.hasError) && <>{this.renderErrorModal()}</>}
        </>);
    }
}

export default withRouter(PlayerPage);
